import React, { useEffect, useState } from "react";
import { createComponent, FelaComponent } from "react-fela";
import LinesEllipsis from "react-lines-ellipsis";
import responsiveHOC from "react-lines-ellipsis/lib/responsiveHOC";
const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis);

const decodeEntities = text =>
    text.replace(/&(#x?[0-9a-f]+|[a-z]+);/gi, (entity, code) => {
        const namedEntities = {
            amp: "&",
            gt: ">",
            lt: "<",
            nbsp: " ",
            quot: '"',
            apos: "'"
        };

        if (code.charAt(0) === "#") {
            const value =
                code.charAt(1).toLowerCase() === "x"
                    ? parseInt(code.slice(2), 16)
                    : parseInt(code.slice(1), 10);

            return Number.isNaN(value) ? entity : String.fromCharCode(value);
        }

        return namedEntities[code.toLowerCase()] || entity;
    });

const stripHTML = text =>
    decodeEntities(text.replace(/<[^>]*>/g, " "))
        .replace(/\s+/g, " ")
        .trim();

export default ({ text, extend, maxLines = 2, maxHeight = 100 }) => {
    const [shouldTruncate, setValue] = useState(false);

    if (!text) {
        return null;
    }

    const sanitizedText = stripHTML(text);

    useEffect(() => {
        // Delaying resize timeout after initial render
        setTimeout(() => {
            setValue(true);
        }, 10);
    });

    if (!shouldTruncate) {
        return (
            <FelaComponent style={untruncatedTextStyle(maxHeight)}>
                {sanitizedText}
            </FelaComponent>
        );
    } else {
        return (
            <FixedHeightExcerpt extend={extend}>
                <ResponsiveEllipsis
                    text={sanitizedText}
                    maxLine={maxLines}
                    ellipsis="..."
                    trimRight
                    basedOn="words"
                    style={{ whiteSpace: "pre-wrap" }}
                />
            </FixedHeightExcerpt>
        );
    }
};

const untruncatedTextStyle = maxHeight => ({
    maxHeight: maxHeight,
    overflow: "hidden"
});

const FixedHeightExcerpt = createComponent(() => {});
